import React from 'react'
import { Helmet } from 'react-helmet'
import CaseStudiesDetail from './case-studies-detail'
import SimplifiedFooter from '../../partials/footer/simplified'
import NoContextHeader from '../../partials/header/no-context-header'
import { Loading } from '../../../shared/ui/loading'
import { useData } from '../../../shared/hooks/use-data'

const CaseStudiesDetailContainer = props => {
  const { state, result, error } =  useData(`/api/case-studies/${props.match.params.id}`)
  const isLoading = state === 'PENDING'

  return (
    <>
      <Helmet>
        {!isLoading && !error && <title>{result.title} - VicBooth</title>}
      </Helmet>
      <NoContextHeader />
      {isLoading
        ? <div><Loading /></div>
        : error || <CaseStudiesDetail {...result} />}
      <SimplifiedFooter />
    </>
  )
}

export default CaseStudiesDetailContainer
